export default "__VITE_ASSET__6a99e5fc__"